const initialState = {
    showBtn: "product",
    showForm:""
}

const inventoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_SHOW_PRODUCT_MODULE_BTN':
            return { ...state, showBtn: action.value }
            break
        case 'HANDLE_SHOW_PRODUCT_MODULE_FORMS':
            return { ...state, showForm: action.value }
            break
        default:
            return state
    }
}

export default inventoryReducer